var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteLeftLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31558 5.51492C7.07432 4.55793 8.22869 4 9.44997 4H18C20.2091 4 22 5.79086 22 8V16C22 18.2091 20.2091 20 18 20H9.44997C8.22869 20 7.07432 19.4421 6.31558 18.4851L2.65164 13.8638C1.78602 12.772 1.78602 11.228 2.65164 10.1362L6.31558 5.51492ZM9.44997 6C8.83933 6 8.26214 6.27897 7.88277 6.75746L4.21883 11.3787C3.93029 11.7427 3.93029 12.2573 4.21883 12.6213L7.88277 17.2425C8.26214 17.721 8.83933 18 9.44997 18H18C19.1046 18 20 17.1046 20 16V8C20 6.89543 19.1046 6 18 6H9.44997Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2929 9.29289C10.6834 8.90237 11.3166 8.90237 11.7071 9.29289L13 10.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L14.4142 12L15.7071 13.2929C16.0976 13.6834 16.0976 14.3166 15.7071 14.7071C15.3166 15.0976 14.6834 15.0976 14.2929 14.7071L13 13.4142L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071C9.90237 14.3166 9.90237 13.6834 10.2929 13.2929L11.5858 12L10.2929 10.7071C9.90237 10.3166 9.90237 9.68342 10.2929 9.29289Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLeftLine);
export default __webpack_public_path__ + "static/media/delete-left-line.30442e2f5e8970e23c89bbcd2da04b82.svg";
export { ForwardRef as ReactComponent };